import React from "react";
import { observer } from "mobx-react-lite";
import { formatAmount, invertDate, switchHyphensToSlashes } from "../../utils/formatters";
import { CollapsibleContentDown } from "../CollapsibleContentDown";
import { TextListItem } from "../TextListItem";
import { Grid, Tag } from "@telefonica/mistica";
import { strings } from "../../localization";
import { Box } from "@chakra-ui/react";

export interface installments {
	data: string;
	value: number;
	status?: "open" | "paid";
}
interface IProps {
	installments: installments[];
	analytic?(): Promise<void> | void;
}

export const DebitFGTSInstallments: React.FC<IProps> = observer(({ installments, analytic }) => {
	const { title, installmentsText } = strings.components.debitFGTSInstallments;

	const tagRender = (status?: "open" | "paid"): React.ReactElement | undefined => {
		if (!status) {
			return;
		}

		return (
			<Box alignSelf="self-end">
				<Tag type={status === "open" ? "inactive" : "success"}>{strings.components.debitFGTSInstallments.status[status]}</Tag>
			</Box>
		);
	};

	return (
		<CollapsibleContentDown title={title} analytic={analytic}>
			<Grid gap={16}>
				{installments.map((quota, index) => (
					<TextListItem
						key={index}
						title={installmentsText(index + 1)}
						name={switchHyphensToSlashes(invertDate(quota.data))}
						description={formatAmount(quota.value)}
						tag={tagRender(quota.status)}
					/>
				))}
			</Grid>
		</CollapsibleContentDown>
	);
});
